export const GENRES = [
  { id: "estrada", name: "Estrada", tags: "Lithuanian estrada, 80s retro pop, warm synths, melodic vocals" },
  { id: "pop", name: "Popsas", tags: "modern Lithuanian pop, catchy hooks, polished radio production" },
  { id: "rokas", name: "Rokas", tags: "Lithuanian rock, driving electric guitars, live drums, powerful vocals" },
  { id: "hiphop", name: "Hip-hopas", tags: "Lithuanian hip-hop, boom bap beat, deep 808 bass, confident rap vocals" },
  { id: "liaudies", name: "Liaudies", tags: "Lithuanian folk ballad, kankles zither, violin, accordion, tender vocals" },
  { id: "sutartines", name: "Sutartinės", tags: "modern sutartines, folktronica, polyphonic female choir, ambient flute, tribal percussion" },
  { id: "synthwave", name: "Synthwave", tags: "dark synthwave, 80s analog bass, arpeggiators, dreamy vocals" },
  { id: "slageris", name: "Šlageris", tags: "Lithuanian schlager, accordion, upbeat waltz-polka rhythm, festive sing-along vocals" },
  { id: "edm", name: "EDM", tags: "euphoric EDM, festival drop, big synth leads, energetic vocals" },
  { id: "dzazas", name: "Džiazas", tags: "smooth jazz, upright bass, piano, saxophone, sultry vocals" },
  { id: "metalas", name: "Metalas", tags: "heavy metal, distorted guitars, double kick drums, aggressive vocals" },
  { id: "akustine", name: "Akustinė", tags: "acoustic singer-songwriter, fingerpicked guitar, intimate vocals" },
];

export const MOODS = [
  { id: "linksma", name: "Linksma", tags: "happy, uplifting" },
  { id: "melancholiska", name: "Melancholiška", tags: "melancholic, bittersweet" },
  { id: "romantiska", name: "Romantiška", tags: "romantic, tender" },
  { id: "energinga", name: "Energinga", tags: "energetic, fast tempo" },
  { id: "svajinga", name: "Svajinga", tags: "dreamy, atmospheric" },
  { id: "epine", name: "Epinė", tags: "epic, cinematic, anthemic" },
];

export const VOICES = [
  { id: "moteris", name: "Moteriškas", tags: "female lead vocals" },
  { id: "vyras", name: "Vyriškas", tags: "male lead vocals" },
  { id: "duetas", name: "Duetas", tags: "male and female duet vocals" },
  { id: "choras", name: "Choras", tags: "choir vocals" },
];

export const LYRIC_TAGS = ["[Įžanga]", "[Strofa]", "[Priešpriedainis]", "[Priedainis]", "[Tiltas]", "[Pertrauka]", "[Pabaiga]"];

export const IDEAS = [
  "Jautri baladė apie naktinį Vilniaus senamiestį lyjant lietui",
  "Energingas rokas apie vasaros naktis prie Baltijos jūros",
  "Elektroninė sutartinė su synthwave ritmu ir etnografiniais motyvais",
  "Smagus šlageris apie močiutės sodą ir Jonines",
  "Hip-hopas apie Kauno gatves ir svajones",
  "Romantiška daina apie pirmą pasimatymą Užupyje",
];

const VOC = "Su vokalu (lietuviškai)";
const INS = "Instrumentiniai (be vokalo)";
export const ENGINES = [
  { id: "minimax", group: VOC, name: "Banga v2.5 · MiniMax", note: "Geriausias lietuviškas vokalas ir struktūra", tag: "Rekomenduojamas" },
  { id: "minimax26", group: VOC, name: "MiniMax Music 2.6", note: "Naujausia MiniMax versija, turtingesnės aranžuotės", tag: "Naujausias" },
  { id: "minimax2", group: VOC, name: "MiniMax Music 2.0", note: "Stabilus, trumpesnis stiliaus aprašymas", tag: "Tik su žodžiais", needsLyrics: true },
  { id: "minimax15", group: VOC, name: "MiniMax Music 1.5", note: "Greitas, tekstas iki 600 simbolių", tag: "Trumpi tekstai", needsLyrics: true },
  { id: "elevenlabs", group: VOC, name: "Aidas · ElevenLabs", note: "Kinematografinis skambesys, tikslus ilgis", tag: "Studijinė kokybė" },
  { id: "lyria3", group: VOC, name: "Google Lyria 3", note: "Naujausias Google modelis su vokalu", tag: "Naujas" },
  { id: "ace", group: VOC, name: "ACE-Step", note: "Atviras modelis, iki 4 min., pigesnis", tag: "Pigus" },
  { id: "diffrhythm", group: VOC, name: "DiffRhythm", note: "Greitas, 1,5 arba 4,7 min. dainos", tag: "Eksperimentinis", needsLyrics: true },
  { id: "ace_auto", group: INS, name: "ACE-Step Auto", note: "Instrumentinė muzika iš aprašymo", tag: "Be vokalo", instrumentalOnly: true },
  { id: "lyria2", group: INS, name: "Google Lyria 2", note: "Aukštos kokybės ~30 s instrumentalas", tag: "Be vokalo", instrumentalOnly: true },
  { id: "stable25", group: INS, name: "Stable Audio 2.5", note: "Instrumentalas iki ~3 min.", tag: "Be vokalo", instrumentalOnly: true },
  { id: "stable", group: INS, name: "Stable Audio Open", note: "Trumpos kilpos ir garsai iki 47 s", tag: "Be vokalo", instrumentalOnly: true },
  { id: "cassette", group: INS, name: "CassetteAI", note: "Itin greitas instrumentalas iki 3 min.", tag: "Greičiausias", instrumentalOnly: true },
  { id: "yue_local", group: "Vietinis", name: "YuE2 vietinis", note: "Tavo kompiuteryje, nemokamai", tag: "Nemokamas" },
];

export const LLMS = [
  { id: "claude-sonnet", group: "Anthropic", name: "Claude Sonnet 5.5", note: "Geriausiai rašo lietuviškai – rimai ir ritmas", tag: "Rekomenduojamas" },
  { id: "claude-opus", group: "Anthropic", name: "Claude Opus 5.5", note: "Giliausia poezija, šiek tiek lėtesnis", tag: "Aukščiausia kokybė" },
  { id: "gpt-5.5", group: "OpenAI", name: "GPT-5.5", note: "Kūrybiški vaizdiniai ir siužetai", tag: "Universalus" },
  { id: "gemini-pro", group: "Google", name: "Gemini 3.1 Pro", note: "Stiprus kalbos ir konteksto supratimas", tag: "Išmanus" },
  { id: "gemini-flash", group: "Google", name: "Gemini 3 Flash", note: "Greičiausias ir pigiausias", tag: "Greitas" },
];

const SEC = { short: 60, medium: 120, long: 210 };
const cap = (rate, hi) => (sec) => rate * Math.min(sec, hi);
const flat = (v) => () => v;
const PRICING = {
  minimax: [flat(0.15), "~1–2 min"], minimax26: [flat(0.15), "~1–2 min"], minimax2: [flat(0.03), "~1 min"],
  minimax15: [flat(0.03), "~40 s"], elevenlabs: [cap(0.01, 600), "~1 min"], lyria3: [flat(0.04), "~40 s"],
  ace: [cap(0.0002, 240), "~30 s"], diffrhythm: [(s) => (s <= 120 ? 0.095 : 0.285), "~2–3 min"],
  ace_auto: [cap(0.0002, 240), "~30 s"], lyria2: [flat(0.1), "~20 s"], stable25: [flat(0.2), "~15 s"],
  stable: [flat(0.02), "~30 s"], cassette: [cap(0.02 / 60, 180), "~20 s"], yue_local: [flat(0), "priklauso nuo PC"],
};
export const engineCost = (id, length) => PRICING[id][0](SEC[length] || 120);
export const fmtUsd = (v) => (v === 0 ? "Nemokamai" : v < 0.01 ? "<$0.01" : `~$${v.toFixed(2)}`);
export const engineMeta = (length) => (e) => `${fmtUsd(engineCost(e.id, length))} · ${PRICING[e.id][1]}`;

export const findItem = (items, id) => items.find((x) => x.id === id) || items[0];

export const LENGTHS = [
  { id: "short", name: "Trumpa · ~1 min" },
  { id: "medium", name: "Vidutinė · ~2 min" },
  { id: "long", name: "Ilga · ~3–4 min" },
];

export const STATUS = {
  queued: { label: "Eilėje", pct: 8 },
  lyrics: { label: "Rašomi žodžiai", pct: 25 },
  music: { label: "Kuriama muzika ir vokalas", pct: 60 },
  saving: { label: "Įrašoma", pct: 92 },
  local_waiting: { label: "Laukia YuE2 Studio tavo kompiuteryje", pct: 15 },
  local_running: { label: "YuE2 Studio kuria dainą", pct: 55 },
  completed: { label: "Paruošta", pct: 100 },
  failed: { label: "Klaida", pct: 100 },
};

export const genreName = (id) => GENRES.find((g) => g.id === id)?.name || "";

export const buildStyle = (genre, moods, voice, extra) => [
  GENRES.find((g) => g.id === genre)?.tags,
  ...MOODS.filter((m) => moods.includes(m.id)).map((m) => m.tags),
  VOICES.find((v) => v.id === voice)?.tags,
  extra,
].filter(Boolean).join(", ");
